import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AnchorLink from 'react-anchor-link-smooth-scroll';

function Eternal() {
    window.scrollTo(0, 0);
    const [focus, setFocus] = React.useState(false);
    return (
        <div>
            <Helmet>

                <title>100% Growth in Lab-Grown Diamond Orders within 4 months in KSA</title>
                <meta name="description" content="" />
                <link rel="canonical" href="https://anbluxury.com/case-studies/adani-realty-case-study.html" />

            </Helmet>
            {/* first fold */}
            <div className="casestudy">
                <div className="box padmmdt padmmdb">

                    <Container>

                        <p className="text-left p1 pdl10"> <span class="spcase">ETERNAL</span> </p>
                    </Container>

                    <Container fluid className="padbsmt padbsmb">
                        <Row>
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <div className="circleboxfirst circleboxfirst-relative  padssmb">
                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="roundbx" width="30%" alt="" />

                                    <div className="boxcentered tpfold">
                                        <h4 className="d-none d-sm-block cuspn"> <span class=""> 100% Growth in Lab-Grown </span><br />  Diamond Orders within 4 months in KSA  <br /></h4>
                                        <h4 className="d-block d-sm-none"> <span class="cuspn"> 100% Growth in Lab-Grown </span>  <br />  Diamond Orders within 4 months in KSA  <br /></h4>

                                    </div>
                                </div>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                    </Container>
                </div>
            </div>
            {/* The brand fold */}
            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>BRAND</strong>  </p>
                            <p className="marbmdt mbt20 ">
                                Eternal is a luxury Lab-Grown Diamond Jewelry brand based in Jeddah, Kingdom of Saudi Arabia. Their motto is clean, sustainable diamond jewelry that can replace the unfair practices of mined diamonds and mimic the same quality, design, and shine of natural diamonds.
                            </p>
                            <br></br>
                            <br></br>
                        </Col>


                        <Col lg={{ span: 5 }} md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 12 }} className="offset-lg-1 mbpdr15">
                            <br></br>
                            <br></br>
                            <br></br>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/eternal-the-brand.png`} width="100%" height="100%" className="img-fluid text-right" />
                        </Col>

                        <Col lg="10" md="10" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>OBJECTIVE</strong>  </p>
                            <br></br>
                            <br></br>
                            <p className="">
                                1. Boost Online orders by convincing skeptical customers.
                            </p>
                            <p className="">
                                2. Reaching affluent customers who can afford and will buy diamonds online.
                            </p>
                            <p className="">
                                3. Improve Brand Perception and be the preferred choice for lab-grown diamonds.
                            </p>
                            <br></br>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* The opportunity */}


            <div id="letsdo" className="seoapproach bgbl padmmdt padmmdb ">
                <Container>
                    <div className="appbox padssmb d-none d-sm-block">
                        <img src={`${process.env.PUBLIC_URL}/img/approach2.png`} className="imgwidt img-fluid" alt="" />
                        <div className="top-left">
                            <h4><strong> Saudi Arabia </strong><br /> <i>Customers </i></h4>
                            <p>Saudi Arabia customers still prefer natural diamonds and accept it as a traditional norm.</p>
                        </div>

                        <div className="top-right">
                            <h4><strong>Skepticism  </strong><br /> <i>About Authenticity</i></h4>
                            <p>Some consumers see lab-grown diamonds as “fake,” so educating them is crucial.</p>
                        </div>

                        <div className="bottom-left">
                            <h4><strong>Conversions</strong></h4>
                            <p>Higher AOV Online conversions are challenging for a new brand with no trust factors.</p>
                        </div>


                        <div className="bottom-right">
                            <h4><strong>Website </strong></h4>
                            <p>Website was not CRO optimised and had poor UI/UX, navigation had quite a bit of room for improvement</p>
                        </div>
                        <div className="centered"><h1>The <span>Challenge</span></h1></div>
                    </div>

                    <Row>
                        <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <img className='d-none d-sm-block' style={{ width: '100%' }} src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/eternal-problem-metrics.png`} alt='' />
                            <br></br>
                            <br></br>
                            <br></br>
                        </Col>
                        <Col md={2} lg={2}></Col>
                    </Row>

                    <div className="appbox padssmb d-none d-sm-block">
                        <img src={`${process.env.PUBLIC_URL}/img/approach2.png`} className="imgwidt img-fluid" alt="" />
                        <div className="top-left">
                            <h4><strong> Inventory </strong><br /> <i>Planning </i></h4>
                            <p>Inventory planning was not optimum, restocking was manual.</p>
                        </div>

                        <div className="top-right">
                            <h4><strong>High Quality  </strong><br /> <i>Images</i></h4>
                            <p>High Quality Images were missing leading to a perception gap</p>
                        </div>

                        <div className="bottom-left">
                            <h4><strong>Advertising</strong></h4>
                            <p>Advertising was not very effective, geographies and the intent and income of the customer wasn’t targeted.</p>
                        </div>


                        <div className="bottom-right">
                            <h4><strong>Bounce Rate </strong></h4>
                            <p>Very high bounce rate, which could mean misdirected traffic or they didn’t find what they were looking for. </p>
                        </div>
                        <div className="centered"><h1>The <span>Challenge</span></h1></div>
                    </div>

                    <div className="appbox  padssmb d-block d-sm-none">
                        <h1>The <span>Challenge</span></h1> <br />

                        <h4><strong> Saudi Arabia </strong><br /> <i>Customers </i></h4>
                        <p>Saudi Arabia customers still prefer natural diamonds and accept it as a traditional norm.</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Skepticism  </strong><br /> <i>About Authenticity</i></h4>
                        <p>Some consumers see lab-grown diamonds as “fake,” so educating them is crucial.</p>

                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Conversions</strong></h4>
                        <p>Higher AOV Online conversions are challenging for a new brand with no trust factors.</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Website </strong></h4>
                        <p>Website was not CRO optimised and had poor UI/UX, navigation had quite a bit of room for improvement</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong> Inventory </strong><br /> <i>Planning </i></h4>
                        <p>Inventory planning was not optimum, restocking was manual.</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>High Quality  </strong><br /> <i>Images</i></h4>
                        <p>High Quality Images were missing leading to a perception gap</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Advertising</strong></h4>
                        <p>Advertising was not very effective, geographies and the intent and income of the customer wasn’t targeted.</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Bounce Rate </strong></h4>
                        <p>Very high bounce rate, which could mean misdirected traffic or they didn’t find what they were looking for. </p>
                    </div>

                    <Row>
                        <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <img className='d-block d-sm-none' style={{ width: '100%' }} src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/eternal-problem-metrics.png`} alt='' />
                            <br></br>
                            <br></br>
                            <br></br>
                        </Col>
                        <Col md={2} lg={2}></Col>
                    </Row>




                </Container>
                {/* <img src={`${process.env.PUBLIC_URL}/img/approach.png`} className="img-fluid" /> */}
            </div>

            {/* The Solution Fold */}

            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="10" md="10" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>SOLUTION</strong>  </p>
                        </Col>
                        <Col lg="10" md="10" sm="12" xs="12" className="offset-lg-1 ">
                            <table className='solution-table'>
                                <thead>
                                    <tr>
                                        <th>Problem</th>
                                        <th>Opportunity</th>
                                        <th>What We Do (Solution)What We Do (Solution)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='golden-cell'>Natural diamonds seen as the norm</td>
                                        <td>Reposition lab grown as modern luxury</td>
                                        <td>“Same diamond, different origin” messaging, comparison pages, premium storytelling, gifting cues</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>High AOV online conversions are challenging</td>
                                        <td>Build confidence to purchase online</td>
                                        <td>Trust stack: certifications, warranty, returns, COD if feasible, concierge, appointment led selling</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Authenticity scepticism, “fake” perception</td>
                                        <td>Education can become a conversion asset</td>
                                        <td>Proof content: IGI certificate explainer, laser inscription video, lab vs natural FAQs, myth busters</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Website not CRO optimised, weak UI UX</td>
                                        <td>Conversion uplift is available quickly</td>
                                        <td>Navigation cleanup, stronger PDP layout, clearer CTAs, faster pages, localised copy, simplified checkout</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Inventory planning not optimum, restocking manual</td>
                                        <td>Prevent stockouts on winners</td>
                                        <td>ABC analysis, reorder points, automated low stock alerts, best seller restock calendar</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>High quality images missing</td>
                                        <td>Luxury perception is built visually</td>
                                        <td>New product photography, 360 video, on hand scale shots, editorial sets, UGC curation</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Ads not effective, wrong geo and intent</td>
                                        <td>Paid can become predictable</td>
                                        <td>Separate campaigns by intent, city, audience tier, search intent structure, retargeting with proof assets</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Very high bounce rate</td>
                                        <td>Message match fixes bounce</td>
                                        <td>Dedicated landing pages per campaign, tighter keyword to page mapping, speed fixes, heatmap led changes</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Container>
            </div>


            <div className=" seoapproach bgbl padbxsb">

                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span><strong> PROCESS</strong> </p>
                            <div className='solution-item'>

                            </div>
                            <h2 className="tcgold marbxst marbxsb padssmt">Market Analysis:</h2>
                            <p><strong>Saudi Population insights</strong></p>
                            <ul className='solution-list' style={{ color: '#fff' }}>
                                <li>The Young Saudi Population is 36.7% of the population. (15-34 age group)</li>
                                <li>They prefer a wide range of options, appealing to their diverse preferences.</li>
                                <li>Peer influence and social media trends significantly impact their choices.</li>
                            </ul>
                            <br></br>
                            <div className='solution-item-graphs'>
                                <p><strong>1. Global size of Lab Grown Diamonds by Country</strong></p>
                                <Row>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/growth-diamond-by-country.png`} />
                                    </Col>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>UAE tops in ME followed by KSA for Lab Grown Diamond.</li>
                                            <li>Expected to grow by 75% in 5 years.</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                            <div className='solution-item-graphs'>
                                <p><strong>2. Lab Grown Diamond Digital Demand in GCC (2024)</strong></p>
                                <Row>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/growth-diamond-gcc.png`} />
                                    </Col>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>UAE captures 61% of the demand.</li>
                                            <li>KSA is second with 21% of demand which means awarenes would have to be created.</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                            <div className='solution-item-graphs'>
                                <p><strong>3. Lab Grown Diamond Demand in KSA - City Wise</strong></p>
                                <Row>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/growth-diamond-ksa.png`} />
                                    </Col>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>Riyadh has ~50% of the demand in KSA.</li>
                                            <li>Jeddah has 23% of the demand in KSA and 4.7% of the demand in GCC. </li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                            <div className='solution-item-graphs'>
                                <p><strong>4. Where Luxury Consumers are in Jeddah</strong></p>
                                <Row>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/jeddah-consumers.png`} />
                                    </Col>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/jeddah-consumers-graphs.png`} />
                                        <Row>
                                            <Col lg="6" md="6" sm="6" xs="6">
                                                <ul className='solution-list' style={{ color: '#fff', padding: 0 }}>
                                                    <li>Al Shati</li>
                                                    <li>Cornishe Road</li>
                                                    <li>Tahlia street</li>
                                                    <li>Al Rawdah</li>
                                                    <li>King Road</li>
                                                </ul>
                                            </Col>
                                            <Col lg="6" md="6" sm="6" xs="6">
                                                <ul className='solution-list' style={{ color: '#fff', padding: 0 }}>
                                                    <li>Obhur</li>
                                                    <li>Andalus</li>
                                                    <li>Al Hamra</li>
                                                    <li>Al Zahraa</li>
                                                </ul>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">Opportunities For the Brand:</h2>

                            <div className='solution-item-graphs'>
                                <Row>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>Customisation- Most customers have a vision for their designs. With Eternal, they could customize every detail to match their exact needs.</li>
                                            <li>Lab diamonds demand grew by 76% digitally, making it an opportunistic market. </li>
                                            <li>Lab diamonds demand grew by 76% digitally, making it an opportunistic market. </li>
                                            <li>Lab diamonds demand grew by 76% digitally, making it an opportunistic market. </li>
                                        </ul>
                                    </Col>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/oppurtunity.png`} />
                                    </Col>

                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">Strategic Approach:</h2>
                            <div className='solution-item-graphs'>
                                <p><strong>From 0% orders to 100% orders in 4 months</strong></p>
                                <Row>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/strategic-approach.png`} />
                                        <br></br>
                                        <p><strong>How did we reach the right target audience?</strong></p>
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>Active Discovery: For the ones in Saudi that are actively searching on digital for lab grown diamond, competitor brands in the category, our brand to show up for those searches.</li>
                                            <li>Passive Discovery: Reach to the affluents in Saudi when they are passively scrolling on Instagram/Facebook, news websites on Google, YouTube</li>
                                        </ul>
                                    </Col>

                                    <Col lg="6" md="6" sm="12" xs="12">

                                        <p><strong>Who did we target?</strong></p>
                                        <p>People who qualified our OSIDE income targeting criteria +</p>
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>People who are engaged and going to get married.</li>
                                            <li>People who have their anniversaries and birthdays coming up.</li>
                                            <li>People who search for ‘diamond jewellery’ and such keywords. </li>
                                            <li>People looking for lab-grown diamonds specifically </li>
                                            <li>People looking for competition</li>
                                        </ul>
                                    </Col>
                                </Row>

                            </div>
                        </Col>
                    </Row>






                </Container>
            </div>

            <div className="bgbl casestudy">
                <Container>
                    <Row>
                        <Col sm={12}>
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong style={{ color: '#fff' }}>COMMUNICATION</strong>  </p>
                        </Col>
                    </Row>
                    <Process />
                </Container>

            </div>



            <div className=" seoapproach bgbl padbxsb">

                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">ACTION</span><strong> PLAN</strong> </p>

                            <div className='solution-item-graphs'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Targeted Advertising:</h2>
                                <Row>
                                    <Col lg="10" md="10" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>Geography</li>
                                            <li>Creatives</li>
                                            <li>Intent</li>
                                            <li>Income segregation</li>
                                            <li>High performing placements</li>
                                            <li>Demographics- Age groups and genders</li>
                                            <li>Behaviour</li>
                                            <li>People visiting Red Sea Mall to increase store footfalls</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                            <div className='solution-item-graphs'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Conversion Rate Optimisation:</h2>
                                <Row>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/conversion-rate-optimization.png`} />
                                    </Col>
                                    <Col lg="6" md="6" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>Optimize store page on website to generate quality leads to the store, features like</li>
                                            <li>We tackled the inventory issue by ramping up our customization feature. Customers can WhatsApp us their design ideas, and we would guide them through an assisted sale to finalize the purchase.</li>
                                            <li>Bug fixes, broken URLs, clean website</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>


                            <div className='solution-item-graphs'>
                                <h2 className="tcgold marbxst marbxsb padssmt">WhatsApp Marketing/ Assisted Sales:</h2>
                                <Row>
                                    <Col lg="10" md="10" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>As a luxury digital agency, we understand that while buying high value products, people need assistance.</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>


                            <div className='solution-item-graphs'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Strategy:</h2>
                                <Row>
                                    <Col lg="7" md="7" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>Our insight was that  its popular in the culture to wear bigger diamond jewelry, we should add stock on the website for bigger pieces.</li>
                                        </ul>
                                    </Col>

                                    <Col lg="5" md="5" sm="12" xs="12">
                                        <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/eternal/strategy.png`} />
                                    </Col>

                                </Row>
                            </div>

                            <div className='solution-item-graphs'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Drive brand awareness:</h2>
                                <Row>
                                    <Col lg="10" md="10" sm="12" xs="12">
                                        <ul className='solution-list' style={{ color: '#fff' }}>
                                            <li>Content promotion</li>
                                            <li>Follower increase to boost perception.</li>
                                            <li>Recommending influencer strategy</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>




            <div className="lgbox build endbox">
                <Container fluid className="pdlr0">
                    <Row className="text-left  mglr0">

                        <Col lg="6" sm="6" xs="12">
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                <Row className="marssmt marssmb mglr0">

                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/isaia.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">ISAIA </h4>
                                        <p>Store Footfalls increased by 100% in 4 months </p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>

                        <Col lg="6" sm="6" xs="12" className="bgbl " >
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                <Row className="marssmt marssmb mglr0">
                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/saundh.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">Saundh </h4>
                                        <p>5X Improvement in E-Commerce Conversion Rate.</p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}
export default Eternal;


function Process() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    adaptiveHeight: true,
                }
            },],
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    adaptiveHeight: false,
                }
            },]
    };
    const next = () => {
        Slider.current.slickNext();
    }
    const previous = () => {
        Slider.current.slickPrev();
    }
    return (
        // <Container fluid className="reasons padslgt padslgb casestudy ">
        <Container fluid className="reasons padslgb casestudy ">
            <Row>
                <Col lg="10" className="offset-lg-1">
                    <Slider {...settings}>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Intent Targeting</span></h2>
                                    <ul className='process-slider-list'>
                                        <li>Based on interests</li>
                                        <li>Based on occasion (for eg engagement rings, promise rings etc.)
                                            Gifting
                                        </li>
                                        <li>Hyper-local targeting based on luxury locations</li>
                                    </ul>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_1.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Awareness</span></h2>
                                    <ul className='process-slider-list'>
                                        <li>Remarket to the customers, instilling brand recognition</li>
                                        <li>Trigger- piqued by the initial exposure, consumers start looking for more information.
                                        </li>
                                        <li>Content- Infographics, Influencer Collabs with engagements in focus</li>
                                    </ul>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_2.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Consideration</span></h2>
                                    <ul className='process-slider-list'>
                                        <li>Remarket comprehensive product pages, sales and offerings, informational content, price differentiation</li>
                                        <li>Trigger- Consumers recognize the value and benefits of lab-grown diamonds but want to explore options and compare prices.</li>
                                    </ul>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_3.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Purchase Decision</span></h2>
                                    <ul className='process-slider-list'>
                                        <li>Track:  They add the item to their cart, apply any discounts or promo codes, and complete the checkout process.</li>
                                        <li>Redirect customers to the store</li>
                                    </ul>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_4.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                    </Slider>
                </Col>
            </Row>
        </Container>
    );
}
